// src/components/Layout.jsx
import React from "react"
import SidebarContentWrapper from "./SidebarContentWrapper"
import { Outlet } from "react-router-dom"
import { Sidebar, SidebarProvider, SidebarInset, SidebarHeader, SidebarContent, SidebarTrigger } from "./sidebar"
import HeaderCustom from "./headercustom"
import { useAuth } from "@/contexts/AuthContext"

export default function Layout({ children }: { children?: React.ReactNode }) {
  const { user, logout } = useAuth();

  return (
    <SidebarProvider>
      <Sidebar>
        {/* <SidebarHeader /> */}
        <SidebarContent className="p-0">
          {/* Your sidebar menus here */}
          <SidebarContentWrapper/>
        </SidebarContent>
      </Sidebar>
      <SidebarInset className="bg-gradient-to-b from-white via-white to-green-100 min-h-screen">
        {/* Header */}
        <HeaderCustom user={user} handleLogout={logout} />
        
        {/* <SidebarTrigger className="absolute top-20 left-4 z-10 text-white" /> Adjusted position to be below header */}

        {/* Main page content */}
        <div 
        // className="pt-16"
        > {/* Add padding to account for fixed header */}
          {children ? children : <Outlet />}
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
